module.exports = __webpack_public_path__ + "media/images/athletes/1809-cb7598379215f8117369f2ce02f39336.png";